import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useCurrentUser } from "@/entities/current-user";
import { MediaCollection } from "api/media-library";
import type { ReduxRootState } from "@/types/redux-store";

import {
  loadMediaCollections,
  selectMediaCollectionsView,
} from "./collections.model";

export function useMediaCollections() {
  const dispatch = useDispatch();
  const user = useCurrentUser();
  const { collections, loadingError, isLoading } = useSelector<
    ReduxRootState,
    {
      collections?: MediaCollection[];
      loadingError?: Error | boolean | null;
      isLoading?: boolean;
    }
  >(selectMediaCollectionsView);

  useEffect(() => {
    void (dispatch(loadMediaCollections() as never) as Promise<unknown>).catch(
      () => {}
    );
  }, [dispatch, user]);

  return {
    collections,
    loadingError,
    isLoading,
  };
}
